<ion-header>
    <app-page-header
        [hideBorder]="true"
        [pageTitle]="jurisdictionName + ' Facilities'"></app-page-header>
</ion-header>
<ion-content>
    <app-page-template>
        <section id="page-title">
            <p>Select the location to search for {{ jurisdictionName | lowercase }} facilities:</p>
        </section>
        <section id="page-content">
            <ion-spinner *ngIf="loading" class="d-block mx-auto mt-4"></ion-spinner>
            <form [formGroup]="filterForm" *ngIf="!loading" novalidate>
                <!-- State Selection -->
                <ion-item lines="none">
                    <ion-label position="stacked">STATE</ion-label>
                    <ion-select formControlName="state" placeholder="Select state">
                        <ion-select-option *ngFor="let stateOption of states" [value]="stateOption">
                            {{ stateOption.Name }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>

                <ion-item lines="none" *ngIf="isLocal">
                    <ion-label position="stacked">CITY</ion-label>
                    <ion-select formControlName="city" placeholder="Select city">
                        <ion-select-option *ngFor="let cityOption of cities" [value]="cityOption">
                            {{ cityOption }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>
            </form>

            <!-- Facility Results -->
            <app-facility-results
                *ngIf="searchAttempted || searching"
                [facilities]="facilityResults"
                [searching]="searching"
                [searchAttempted]="searchAttempted"
                (facilitySelected)="selectFacility($event)"></app-facility-results>
        </section>
        <app-cta-buttons
            [secondaryCtaLabel]="searchAttempted ? 'Can\'t find your facility? Contact Support' : ''"
            secondaryCtaId="secondary-cta"
            (secondaryCtaClick)="openSupportLink()"></app-cta-buttons>
    </app-page-template>
</ion-content>